import "./Contact.module.css";
import MainIndustrialHeader from "@/reusable_sections/Header";
import GlobalSupportHub from "./sections/GlobalSupportHub";
import TechnicalInquiryForm from "./sections/TechnicalInquiryForm";
import IndustrialFooter from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <MainIndustrialHeader />
      <GlobalSupportHub />
      <TechnicalInquiryForm />
      <IndustrialFooter />
    </div>;
}